import React, { useEffect, useState } from "react";
import { Button, Input, message, Row, Col, Space } from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import CategoryDrawer from "./CategoriesDrawer";
import API from "../../api";
import CustomTable from "../../components/Table/CustomTable";
import ConfirmationModal from "../../components/ConfirmationModal";
import { getUserRole } from "../../utils/auth";


export default function Categories() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });
  const [loading, setLoading] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [userRole, setUserRole] = useState("");
      
    
  useEffect(() => {
    setUserRole(getUserRole()); 
  }, []);

  const getCategories = async () => {
    try {
      setLoading(true)
      const { current, pageSize } = paginationInfo;
      const response = await API.get(`/category/paginate`, {
        params: {
          page: current,
          limit: pageSize,
          search: searchQuery,
        },
      });
      setCategories(response.data.categories);
      setPaginationInfo((prev) => ({
        ...prev,
        total: response.data.pagination.totalCategories,
      }));
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch categories. Please try again.");
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getCategories();
  }, [paginationInfo.current, paginationInfo.pageSize, searchQuery]);

  const handleDeleteClick = (category) => {
    setCategoryToDelete(category);
    setIsDeleteModalVisible(true);
  };

  const handleDeleteCategory = async () => {
    try {
      await API.delete(`/category/${categoryToDelete?._id}`);
      message.success("Category deleted successfully!");
      getCategories();
    } catch (err) {
      console.error("Error deleting category:", err);
      message.error(err.response?.data?.message || "Failed to delete category.");
    } finally {
      setIsDeleteModalVisible(false);
    }
  };

  const handleAddCategory = async () => {
    setOpenDrawer(false);
    getCategories();
  };

  const handleEditCategory = async () => {
    setOpenDrawer(false);
    getCategories();
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPaginationInfo((prev) => ({ ...prev, current: 1 }));
  };

  const columns = [
    {
      title: "Index",
      key: "index",
      render: (_, __, index) =>
        (paginationInfo.current - 1) * paginationInfo.pageSize + index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    userRole.editPermission == true &&{

      title: "Actions",
      key: "actions",
      align: "center",
      render: (record) => (
        <div>
          <Button
            icon={<EditOutlined />}
            onClick={() => {
              setIsEdit(true);
              setSelectedCategory(record);
              setOpenDrawer(true);
            }}
          />
          {/* <Button
            danger
            icon={<DeleteOutlined />}
            style={{ marginLeft: 8 }}
            onClick={() => handleDeleteClick(record)}
          /> */}
        </div>
      ),
    },
  ];

  return (
    <div  style={{
      padding: "20px",
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    }}>
    {/* Header Section */}
    <Row
      gutter={[16, 16]}
      style={{ marginBottom: 16 }}
      justify="space-between"
      
    >
      <Col xs={24} sm={12} md={12}>
      <Space style={{ width: '100%' }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setOpenDrawer(true);
            setIsEdit(false);
            setSelectedCategory(null);
          }}
          block
          >
          Add New
        </Button>
        <Input
          placeholder="Search categories"
          prefix={<SearchOutlined />}
          value={searchQuery}
          onChange={handleSearch}
          style={{ width: "100%",minWidth:30 }}
          />
          </Space>
      </Col>
    </Row>

    {/* Drawer Section */}
    <CategoryDrawer
      open={openDrawer}
      setOpen={setOpenDrawer}
      data={selectedCategory}
      isEdit={isEdit}
      onSubmit={isEdit ? handleEditCategory : handleAddCategory}
      parentCategories={categories.filter(
        (category) =>
          !category?.parentCategory &&
          category?._id !== selectedCategory?._id
      )}
    />

    {/* Table Section */}
    <div style={{ overflowX: "auto" }}>
      <CustomTable
        columns={columns}
        dataSource={categories} // Ensure the filtered data is passed here
        onPaginationChange={(pagination) => {
          setPaginationInfo({
            current: pagination.current,
            pageSize: pagination.pageSize,
          });
        }}
        loading={loading}
        total={paginationInfo.total}
      />
    </div>

    {/* Confirmation Modal */}
    <ConfirmationModal
      visible={isDeleteModalVisible}
      onConfirm={handleDeleteCategory}
      onCancel={() => setIsDeleteModalVisible(false)}
      title="Confirm Deletion"
      content="Are you sure you want to delete this category? This action cannot be undone."
    />
  </div>
  );
}
